import { render, staticRenderFns } from "./dataBseManage.vue?vue&type=template&id=5bf6a4df"
import script from "./dataBseManage.vue?vue&type=script&lang=js"
export * from "./dataBseManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports